import axios from 'axios';
import { API_URL } from '../config';

class BackServer {
    constructor() {
        this.api = axios.create({
            baseURL: API_URL,
            withCredentials: true
        });
    }

    // Add your API methods here
    async get_orderDetails(uuid, count_otvet) {
        const response = await this.api.get(`/v1/orders/review_detail?uuid=${uuid}&count_otvet=${count_otvet}`);
        return response.data;
    }
}

export default new BackServer(); 